import styled from 'styled-components';

import { color } from '~/assets/styles/colors';



export const ButtonArea = styled.div`
	margin-left: 13px;
	margin-top: 18px;
	.buttonComponent {
		width: 100%;
		padding: 16px;
		border-radius: 10px;

		color: ${color.softBlack} !important;
		background-color: ${color.primary}  !important;
		border: 3px solid ${color.primary} !important;

		&:hover,
		&:focus {
			color: ${color.primary}  !important;
			background-color: #fff  !important;
		}
	}
`;
